import React from 'react';

import ReactRender from '../tools/react-render';
import ChampionshipDataBox from '../components/Database/DataBoxes/ChampionshipDataBox';
import RaceDataBox from '../components/Database/DataBoxes/RaceDataBox';
import DriverDataBox from '../components/Database/DataBoxes/DriverDataBox';
import CircuitDataBox from '../components/Database/DataBoxes/CircuitDataBox';

const ChampionshipDataBoxes = document.querySelectorAll('[data-behaviour="championship-data-box"]');

ChampionshipDataBoxes.forEach(dataBox => {
    const championshipId = dataBox.getAttribute('data-championship-id');

    ReactRender(<ChampionshipDataBox championship={championshipId} />, dataBox);
});

const RaceDataBoxes = document.querySelectorAll('[data-behaviour="race-data-box"]');

RaceDataBoxes.forEach(dataBox => {
    const raceId = dataBox.getAttribute('data-race-id');

    ReactRender(<RaceDataBox race={raceId} />, dataBox);
});

const DriverDataBoxes = document.querySelectorAll('[data-behaviour="driver-data-box"]');

DriverDataBoxes.forEach(dataBox => {
    const driverId = dataBox.getAttribute('data-driver-id');

    ReactRender(<DriverDataBox driver={driverId} />, dataBox);
});

const CircuitDataBoxes = document.querySelectorAll('[data-behaviour="circuit-data-box"]');

CircuitDataBoxes.forEach(dataBox => {
    const circuitId = dataBox.getAttribute('data-circuit-id');

    ReactRender(<CircuitDataBox circuit={circuitId} />, dataBox);
});
